<script lang="typescript">
import { onMount } from "svelte";

import type { Meeting } from "../../common/types";
import { isWpSuccess, wpFetchRestApi } from "../../util";
import MeetingComponent from "./MeetingComponent.svelte";


  let meetings:Array<Meeting> = [];

  onMount( async () => {
    const endpoint = 'meeting/meetings';
    const result = await wpFetchRestApi<Array<Meeting>>(endpoint, 'GET');
    if (!isWpSuccess(result)) {
      throw new Error(result.message);
    }
    meetings = result.data;
  });

</script>

<div>
  <h1>Sekalaiset asetukset</h1>

  <h2>Kokousten kellonajan korjaaminen</h2>

  {#each meetings as meeting}
    <MeetingComponent {meeting}>
    </MeetingComponent>
  {/each}

</div>

<style>
</style>

